import Dashboard from '../pages/Dashboard';
import Employees from '../pages/Employees';
import EmployeeForm from '../pages/EmployeeForm';
import EmployeeDetail from '../pages/EmployeeDetail';
import Organization from '../pages/Organization';
import CompanySettings from '../pages/CompanySettings';
import Compliance from '../pages/Compliance';
import VacationBalance from '../pages/VacationBalance';
import Absences from '../pages/Absences';
import Rooms from '../pages/Rooms';
import RoomBooking from '../pages/RoomBooking';
import Cleaning from '../pages/Cleaning';
import EmailSettings from '../pages/EmailSettings';
import Shifts from '../pages/Shifts';
import Massnahmen from '../pages/Massnahmen';
import Personaleinsatz from '../pages/Personaleinsatz';
import Honorarkraefte from '../pages/Honorarkraefte';
import Templates from '../pages/Templates';
import Feiertage from '../pages/Feiertage';
import MyProfile from '../pages/MyProfile';
import ChangeRequests from '../pages/ChangeRequests';
import QualificationProposalsInbox from '../pages/QualificationProposalsInbox';
import Einsatzplan from '../pages/Einsatzplan';
import WorkflowTemplates from '../pages/WorkflowTemplates';
import Workflows from '../pages/Workflows';
import WorkflowDetail from '../pages/WorkflowDetail';
import Settings from '../pages/Settings';
import Permissions from '../pages/Permissions';
import Newsfeed from '../pages/Newsfeed';
import EmployeeRequests from '../pages/EmployeeRequests';
import AccountSetup from '../pages/AccountSetup';
import AuditLog from '../pages/AuditLog';
import JobPostings from '../pages/JobPostings';
import Vehicles from '../pages/Vehicles';
import VehicleBooking from '../pages/VehicleBooking';
import Facility from '../pages/Facility';
import AdminTrash from '../pages/AdminTrash';
import Locations from '../pages/Locations';
import LocationForm from '../pages/LocationForm';
import UrlaubHub from '../pages/UrlaubHub';
import ZeiterfassungHub from '../pages/ZeiterfassungHub';
import AdminAuditHub from '../pages/AdminAuditHub';
import Phonebook from '../pages/Phonebook';
import Devices from '../pages/Devices';
import ITSettings from '../pages/ITSettings';
import QMB from '../pages/QMB';
import Recruiting from '../pages/Recruiting';
import PeopleAnalytics from '../pages/PeopleAnalytics';
import { Navigate } from 'react-router-dom';

// Redirect-Wrapper fuer alte Urlaubs-Routen → /urlaub?tab=…
const RedirectToUrlaubMine = () => <Navigate to="/urlaub?tab=mine" replace />;
const RedirectToUrlaubTeam = () => <Navigate to="/urlaub?tab=team" replace />;
const RedirectToUrlaubRequests = () => <Navigate to="/urlaub?tab=requests" replace />;

// Redirect-Wrapper fuer alte Zeiterfassungs-Subrouten
const RedirectToZeitUebersicht = () => <Navigate to="/zeiterfassung?tab=uebersicht" replace />;
const RedirectToZeitKorrekturen = () => <Navigate to="/zeiterfassung?tab=korrekturen" replace />;

// Redirect-Wrapper fuer alte Admin-Audit-Subrouten
const RedirectToAuditConsistency = () => <Navigate to="/admin/audit?tab=konsistenz" replace />;
const RedirectToAuditTimeHealth = () => <Navigate to="/admin/audit?tab=zeit-health" replace />;
const RedirectToAuditWorkingHours = () => <Navigate to="/admin/audit?tab=soll-stunden" replace />;
const RedirectToAuditPermissions = () => <Navigate to="/admin/audit?tab=berechtigungen" replace />;
const RedirectToAuditApi = () => <Navigate to="/admin/audit?tab=api-drift" replace />;
const RedirectToAuditNotifications = () => <Navigate to="/admin/audit?tab=benachrichtigung" replace />;

/**
 * Jede Route kann folgende Gating-Flags tragen (optional):
 *   adminOnly: true                        → nur user.role === 'admin'
 *   permArea: '<area>', permLevel: '<lvl>' → mind. diese Permission-Stufe
 *   (nichts)                               → jede angemeldete Person
 *
 * Ziel: Eine Quelle der Wahrheit. Die Route-Gates müssen mit navConfig.js
 * und dem Backend (require_permission) übereinstimmen — überprüft durch
 * scripts/audit_permissions.py.
 */
export const protectedRoutes = [
  { path: '/dashboard', element: Dashboard },
  { path: '/mein-profil', element: MyProfile },
  { path: '/qmb', element: QMB },

  // Employees
  { path: '/employees', element: Employees, permArea: 'employees', permLevel: 'view' },
  { path: '/employees/new', element: EmployeeForm, permArea: 'employees', permLevel: 'edit' },
  { path: '/employees/:id', element: EmployeeDetail, permArea: 'employees', permLevel: 'view' },
  { path: '/employees/:id/edit', element: EmployeeForm, permArea: 'employees', permLevel: 'edit' },
  { path: '/honorarkraefte', element: Honorarkraefte, permArea: 'employees', permLevel: 'view' },

  // People Analytics / Personalanalyse (nur HR/Admin)
  { path: '/personalanalyse', element: PeopleAnalytics, permArea: 'employees', permLevel: 'view' },

  // Organization
  { path: '/organization', element: Organization, permArea: 'settings', permLevel: 'edit' },
  { path: '/locations', element: Locations, adminOnly: true },
  { path: '/locations/new', element: LocationForm, adminOnly: true },
  { path: '/locations/:id/edit', element: LocationForm, adminOnly: true },
  { path: '/company-settings', element: CompanySettings, permArea: 'settings', permLevel: 'edit' },
  { path: '/devices', element: Devices, adminOnly: true },
  { path: '/it-einstellungen', element: ITSettings, permArea: 'settings', permLevel: 'edit' },
  { path: '/compliance', element: Compliance, permArea: 'compliance', permLevel: 'view' },

  // Vacations — neue zentrale Sammelseite mit Tabs
  { path: '/urlaub', element: UrlaubHub },
  // Alte Routen leiten auf den entsprechenden Tab um (Bookmark-/Email-Kompat.)
  { path: '/vacations', element: RedirectToUrlaubMine },
  { path: '/vacation-requests', element: RedirectToUrlaubRequests },
  { path: '/team-kalender', element: RedirectToUrlaubTeam, permArea: 'vacations', permLevel: 'view' },
  { path: '/vacation-balance', element: VacationBalance, permArea: 'vacations', permLevel: 'view' },

  // Shifts
  { path: '/shifts', element: Shifts, permArea: 'shifts', permLevel: 'view' },
  { path: '/massnahmen', element: Massnahmen, permArea: 'shifts', permLevel: 'edit' },
  { path: '/personaleinsatz', element: Personaleinsatz, permArea: 'shifts', permLevel: 'edit' },
  { path: '/absences', element: Absences, permArea: 'absences', permLevel: 'view' },

  { path: '/rooms', element: Rooms, permArea: 'rooms', permLevel: 'edit' },
  { path: '/raumbuchung', element: RoomBooking },
  { path: '/reinigung', element: Cleaning, permArea: 'rooms', permLevel: 'view' },
  { path: '/email-einstellungen', element: EmailSettings, permArea: 'settings', permLevel: 'edit' },

  // Templates
  { path: '/templates', element: Templates, permArea: 'documents', permLevel: 'view' },

  // Time Tracking — Sammelseite mit Tabs
  { path: '/zeiterfassung', element: ZeiterfassungHub },
  // Alte Subrouten leiten auf den entsprechenden Tab um
  { path: '/zeiterfassung/uebersicht', element: RedirectToZeitUebersicht, permArea: 'time_tracking', permLevel: 'view' },
  { path: '/zeiterfassung/korrekturen', element: RedirectToZeitKorrekturen },

  // Einsatzplan
  { path: '/einsatzplan', element: Einsatzplan },

  // Feiertage (nur lesend; jede/r angemeldete Mitarbeiter darf rein)
  { path: '/feiertage', element: Feiertage },

  // Change Requests
  { path: '/aenderungsantraege', element: ChangeRequests, permArea: 'employees', permLevel: 'view' },
  { path: '/qualifikations-antraege', element: QualificationProposalsInbox, permArea: 'employees', permLevel: 'edit' },

  // Workflows
  { path: '/workflows', element: Workflows, permArea: 'employees', permLevel: 'view' },
  { path: '/workflows/:workflowId', element: WorkflowDetail, permArea: 'employees', permLevel: 'view' },
  { path: '/workflow-templates', element: WorkflowTemplates, permArea: 'employees', permLevel: 'view' },

  // Settings & Permissions
  { path: '/settings', element: Settings },
  { path: '/permissions', element: Permissions, adminOnly: true },
  { path: '/news', element: Newsfeed, permArea: 'news', permLevel: 'view' },
  { path: '/telefonbuch', element: Phonebook },
  { path: '/requests', element: EmployeeRequests },
  { path: '/setup', element: AccountSetup },
  { path: '/audit-log', element: AuditLog, adminOnly: true },
  { path: '/admin/trash', element: AdminTrash, adminOnly: true },
  // Diagnose & Audit — Sammelseite mit 6 Tabs (Admin sieht alle, time_tracking:view-Manager nur Soll-Stunden)
  { path: '/admin/audit', element: AdminAuditHub, permArea: 'time_tracking', permLevel: 'view' },
  // Alte Direktrouten leiten auf den entsprechenden Tab um (Bookmark-Kompat.)
  { path: '/admin/consistency-check', element: RedirectToAuditConsistency, adminOnly: true },
  { path: '/admin/notification-matrix', element: RedirectToAuditNotifications, adminOnly: true },
  { path: '/admin/time-tracking-health', element: RedirectToAuditTimeHealth, adminOnly: true },
  { path: '/admin/api-audit', element: RedirectToAuditApi, adminOnly: true },
  { path: '/admin/permissions-audit', element: RedirectToAuditPermissions, adminOnly: true },
  { path: '/admin/working-hours-audit', element: RedirectToAuditWorkingHours, permArea: 'time_tracking', permLevel: 'view' },
  { path: '/fuhrpark', element: Vehicles, permArea: 'fleet', permLevel: 'view' },
  { path: '/fahrzeugbuchung', element: VehicleBooking },
  { path: '/haustechnik', element: Facility, permArea: 'facility', permLevel: 'view' },
  { path: '/stellenausschreibungen', element: JobPostings, permArea: 'job_postings', permLevel: 'view' },
  { path: '/recruiting', element: Recruiting, permArea: 'job_postings', permLevel: 'view' },
];
